"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOP_OPTIMIZATIONS = void 0;
var client_1 = require("@apollo/client");
exports.STOP_OPTIMIZATIONS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation StopOptimizations($input: OptimizationsInput!) {\n    stopOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n    }\n  }\n"], ["\n  mutation StopOptimizations($input: OptimizationsInput!) {\n    stopOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n      optimizingPausedAt\n    }\n  }\n"])));
var templateObject_1;
